import { useQuery } from '@tanstack/react-query';
import { SectorComercial, UnidadNegocio } from '../../../../../types';
import { HttpCacheOperacion } from '../../../api/httpCacheOperacion';
import { EntidadCache } from 'src/pages/sistema/types/types';

export const useCFUnidadNegocio = (codPais: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: unidadNegocio = [],
    isLoading,
    isError,
    error
  } = useQuery<UnidadNegocio[], Error>({
    queryKey: ['CF-unidad-negocio', codPais, codSistema],
    queryFn: () => HttpCacheOperacion.getUnidadesNegocioPorPaisYSistema(codPais!, codSistema!),
    enabled: !!codPais && !!codSistema
  })

  return {
    unidadNegocio,
    isLoading,
    isError,
    error
  }
}

export const useCFSectorComercialTipos = (codUnidadNegocio: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: sectorComercialTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<SectorComercial[], Error>({
    queryKey: ['CF-sector-comercial-tipos', codUnidadNegocio, codSistema],
    queryFn: () => HttpCacheOperacion.getSectoresComercialesPorUnidadNegocio(codUnidadNegocio!, codSistema!),
    enabled: !!codUnidadNegocio && !!codSistema
  })

  return {
    sectorComercialTipos,
    isLoading,
    isError,
    error
  }
}

export const useCFOperacionTipos = (codPais: number | undefined | null) => {
  const {
    data: operacionTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<EntidadCache[], Error>({
    queryKey: ['CF-operacion-tipos', codPais],
    queryFn: () => HttpCacheOperacion.getCFClienteTIpos(codPais!),
    enabled: !!codPais
  })

  return {
    operacionTipos,
    isLoading,
    isError,
    error
  }
}